export default __webpack_public_path__ + "static/media/camping.075c6361.svg";